import { PostFormRequest, PutFormRequest } from "../../services/ApiClientService"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useTranslation } from "react-i18next"
import { CouponEntity } from "../../Objects/Coupon/CouponEntity"

export const useSaveCoupon = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const handleSaveCoupon = async (coupon: CouponEntity, onSuccess: any) => {
    try {
      enableLoad()

      const response =
        coupon.id !== -1
          ? await PutFormRequest(`${API_ROUTES.COUPON.PUT}/${coupon.id}`, coupon.toJSON())
          : await PostFormRequest(API_ROUTES.COUPON.CREATE, coupon.toJSON())

      if (response.success) {
        onSuccess()

        return
      }

      throw new Error(response.message)
    } catch (e) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return {
    handleSaveCoupon,
  }
}
